<div class="z-fx-col container">
  <media-cta [data]="questionData"></media-cta>
  <p
    class="info-content"
    [innerHTML]="questionData?.content || '' | translateText: 'content' : questionData | formatText | safeHtml"
  ></p>
</div>
